/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSApprovalItemsDialog extends _Ext.ItemEditorDialog<POSApprovalItemsRow> {
        protected getFormKey() { return POSApprovalItemsForm.formKey; }
        protected getLocalTextPrefix() { return POSApprovalItemsRow.localTextPrefix; }
        protected getDeletePermission() { return POSApprovalItemsRow.deletePermission; }
        protected getInsertPermission() { return POSApprovalItemsRow.insertPermission; }
        protected getUpdatePermission() { return POSApprovalItemsRow.updatePermission; }

        public form = new POSApprovalItemsForm(this.idPrefix);

        // #region Public Variables
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        // #region Public Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public Closing: boolean;
        public ItemMaster: any;
        // #endregion

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);

            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.LaborDetails);
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);
            q.hideEditorToolbar(this.form.BOMDetails);
            q.setTextRightAlign(this.form.MF);
            q.setTextRightAlign(this.form.MFAmount);

            this.form.Pieces.changeSelect2(e => {
                if (this.form.HasBom.value)
                    this.CalculateTotals();
                else
                    this.CalculateRate();
            });

            this.form.Weight.changeSelect2(e => {
                if (!isNaN(this.form.Weight.value)) {

                    var lbr = this.form.LaborDetails.getItems();
                    var self = this;
                    lbr.forEach(function (x) {
                        x.Weight = self.form.Weight.value;
                        x.Pieces = self.form.Pieces.value;
                        x.LabourAmount = x.CalcOnId == 61 ? self.form.Pieces.value * x.LabourRate : self.form.Weight.value * x.LabourRate;

                    });

                    this.form.LaborDetails.setItems(lbr);
                    this.CalculateRate();
                }

            });

            this.form.UnitRate.changeSelect2(e => {
                if (this.form.UnitRate.value != null)
                    this.CalculateRate();
            });

            this.form.CalcOnId.changeSelect2(e => {
                if (this.form.CalcOnId.value != "")
                    this.CalculateRate();
            });

            this.form.NetAmount.changeSelect2(e => {
                if (this.form.NetAmount.value != null)
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
            });

            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            //*** BOM row add Edit Delete Event ****
            //Used to Update Amount weight and pieces from BOM to item

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            this.form.Discount.changeSelect2(e => {
                var discount = this.form.Discount.value;
                var labordetails = this.form.LaborDetails.getItems();
                for (var l = 0; l < labordetails.length; l++) {
                    delete labordetails[l]["__id"];
                    delete labordetails[l]["RowNum"];
                }
                Common.CommonService.GetItemDiscount({
                    Discount: discount,
                    LaborDetails: labordetails
                }, response => {
                    var x = response;
                    if (response.Entities == null) {
                        q.Alert('', 'Discount Policies will be affected, cannot apply Discount',2999, true);
                        this.form.Discount.value = 0;
                        return;
                    }
                    if (response.Entities.length > 0) {
                        var labors = response.Entities;
                        this.form.LaborDetails.setData(labors);
                        this.form.GrossAmount.value = this.form.GrossAmount.value - discount;
                        this.form.DiscountPer.value = (discount / this.form.NetAmount.value) * 100;
                        //this.form.LaborDetails.setData(labors);
                    }
                    this.CalculateTotals();
                }, { async: false })
            });

            this.form.UnitLabour.changeSelect2(e => {
                this.form.NetAmount.value = parseFloat(this.form.UnitRate.value.toString()) + parseFloat(this.form.UnitLabour.value.toString());
                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
            });

            this.form.MF.changeSelect2(e => {
                var item = RateHelper.ReCalculateMarkUp(this.form.MF.value, this.form.MFAmount.value, this.form.BOMDetails.getItems(), this.form.LaborDetails.getItems(), this.form.Pieces.value, this.form.Weight.value, this.form.NetWeight.value
                    , this.form.FancyCharges.value, this.form.OtherCharges.value);

                var bomdetails = item.BOMDetails;
                this.form.BOMDetails.setItems(bomdetails);
                this.form.LaborDetails.setItems(item.LaborDetails);
                this.CalculateTotals();
            });

            this.form.StoneRate.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });

            this.form.StoneWeight.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });
        }

        getItem() {
            return this.getSaveEntity();
        }       
        
        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.ItemMaster = (this.parentEditor.parentDialog as POSApprovalDialog);
            this.RateListId = this.ItemMaster.RateListId;
            this.LaborListId = this.ItemMaster.LaborListId;
            this.StoneMarkup = this.ItemMaster.StoneMarkup;
            this.StoneDiscount = this.ItemMaster.StoneDisount;
            this.ExchangeRate = this.ItemMaster.ExchangeRate; 
            this.TransDate = this.ItemMaster.entity.TransDate;
            ItemFieldHelper.SalesItemFields(this, this.ItemMaster.form.VoucherTypeId.value);

            let StockTrans;

            if (this.form.VoucherTypeId.value != null) {
                Stock.StockItemService.GetStockTransactions({
                    RefTransId: Q.parseInteger(this.form.TransId.value),
                    RefVoucherId: this.form.VoucherTypeId.value,
                    RefTransItemId: Q.parseInteger(this.form.TransItemId.value)
                },
                    response => StockTrans = response.Entities,
                    {
                        async: false
                    }
                );


                if (StockTrans.length > 0) {
                    this.setReadOnly(true);
                    this.dialogTitle = this.dialogTitle + ' : View Mode'
                    this.updateInterface();

                }
            }
        } 
    }
}